<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <meta-section>
            <div class="text-right">
              <argon-button :to="{ name: 'Jabatan' }" isRouteLink outline
                ><font-awesome-icon icon="fa-solid fa-chevron-left" />
                Kembali</argon-button
              >
            </div>
          </meta-section>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <argon-button>Simpan</argon-button>
                    <ArgonButton :to="{ name: 'Jabatan' }" outline isRouteLink>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <FieldsetComponent
                title="Periode Penilaian"
                description="Pastikan periode penilaian diisi sesuai dengan periode yang Anda laporkan"
              >
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Jabatan" idinput="name">
                    <input-form
                      type="text"
                      name="name"
                      id="name"
                      v-model="data.name"
                      :isinvalid="!validateInput('name', data.name)" />
                  </form-group>

                  <form-group label="Kode Jabatan" idinput="code">
                    <input
                      type="text"
                      name="code"
                      id="code"
                      v-model="data.code"
                      class="form-control"
                      :disabled="data?.code != null && data?.code != '' && currentCode != ''"
                    />
                  </form-group>

                  <form-group label="Unit Kerja" idinput="unitkerja_id">
                    <select-form name="unitkerja_id" idinput="unitkerja_id" v-model="data.unitkerja_id" :options="unitKerja.map((item) => {
                      return {
                        text: item.name,
                        value: item.id,
                      };
                    })" />
                  </form-group>
                  
                  <form-group label="Nilai Maksimal Kompetensi Inti">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <div
                        v-for="index in 5"
                        :key="index"
                        class="d-flex flex-row gap-4 p-1 align-items-center border"
                      >
                        <argon-radio :id="'inti_' + index" name="inti" :text="index" v-model="data.inti" :value="index" />
                      </div>
                    </div>
                  </form-group>

                  <form-group label="Nilai Maksimal Kompetensi Manajerial" :class="{'form-control is-invalid': !validateInput('manajerial', data.manajerial)}">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <div
                        v-for="index in 5"
                        :key="index"
                        class="d-flex flex-row gap-4 p-1 align-items-center border"
                      >
                        <argon-radio :id="'manajerial_' + index" name="manajerial" :text="index" v-model="data.manajerial" :value="index" uncheckable />
                      </div>
                    </div>
                  </form-group>

                  <form-group label="Bobot Capaian Kinerja" idinput="bobot_capaian_kinerja">
                    <input
                      type="number"
                      max="100"
                      id="bobot_capaian_kinerja"
                      v-model="data.bobot_capaian_kinerja"
                      class="form-control"
                    />
                  </form-group>

                  <form-group label="Bobot Kompentensi" idinput="bobot_kompetensi">
                    <input
                      type="number"
                      max="100"
                      id="bobot_kompetensi"
                      v-model="data.bobot_kompetensi"
                      class="form-control"
                    />
                  </form-group>

                  <form-group label="Jenis Kompetensi">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <argon-radio id="jenis_kompetensi_inti" name="jenis_kompetensi" text="Inti" v-model="data.jenis_kompetensi" value="inti" />
                      <argon-radio id="jenis_kompetensi_inti_dan_manajerial" name="jenis_kompetensi" text="Inti dan Manajerial" v-model="data.jenis_kompetensi" value="inti_dan_manajerial" />
                    </div>
                  </form-group>

                  <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <argon-radio id="status_0" name="status" text="Aktif" v-model="data.status" value="1" />
                      <argon-radio id="status_1" name="status" text="Non Aktif" v-model="data.status" value="0" />
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import JabatanApi from "@/repository/api/JabatanApi";
import RealisasiKpiApi from "@/repository/api/RealisasiKpiApi";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import InputForm from '@/components/InputForm.vue';
import ArgonRadio from "@/components/ArgonRadio.vue";
import SelectForm from '@/components/SelectForm.vue';

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      jabatan: {},
      data: {},
      currentCode: "",
      unitKerja: [],
      optionUnitKerja: [],
      optionJabatan: [],
      myValue: "",
      submitable: true,
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    InputForm,
    ArgonRadio,
    SelectForm,
  },
  async mounted() {
    await this.getUnitKerja();
    if (this.$route.params.id) {
      await this.getData();
      this.currentCode = JSON.parse(JSON.stringify(this.data?.code ?? ""))
    }
  },
  methods: {
    uncheckInti() {
      this.data.inti = ""
    },
    uncheckManajerial() {
      this.data.manajerial = ""
    },
    validateInput(field, data) {
      let test = Boolean
      switch (field) {
        case "name":
          test = /^([\w!@#$%^&*(),.?":{}|<>-](\s?))+$/.test(data)
          break;
        case "prespektif":
          test = /^.+$/.test(data)
          break;
        case "manajerial":
          test = (this.data.jenis_kompetensi == "inti" && data == "") || (this.data.jenis_kompetensi != "inti"  && /^\d{1,}$/.test(data))
          break;
        default:
          break;
      }
      this.submitable = test
      return test;
    },
    async unassignKpi(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        text: "Jika anda unassign pegawai maka progress pegawai tersebut untuk kpi terkait akan ikut dihapus",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await RealisasiKpiApi.delete(id).then(async () => {
            this.$swal({
              icon: "success",
              title: "Berhasil Unassign",
            });
            await this.getRealisasi();
          });
          this.$store.state.loading = false;
        }
      });
    },
    async getRealisasi() {
      this.$store.state.loading = true;
      await RealisasiKpiApi.getbyparam({ kpi_id: this.$route.params.id })
        .then((response) => {
          this.data.realisations = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "ERROR",
            text: error.response.data.message,
          });
        });
      this.$store.state.loading = false;
    },
    getSelectedUnitKerja() {
      return this.unitKerja.find((item) => {
        return item.id == this.data.unit_kerja_id;
      });
    },
    async getOptionUnitKerja() {
      this.optionUnitKerja = this.unitKerja.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
      })
        .then(async (response) => {
          this.unitKerja = response.data;
        })
        .catch(() => {
          this.unitKerja = [];
        });
      await this.getOptionUnitKerja();
      this.$store.state.loading = false;
    },
    async getOptionJabatan() {
      this.optionJabatan = this.jabatan.map((item) => {
        return {
          id: item.id,
          text: item.name,
        };
      });
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.get()
        .then((response) => {
          this.jabatan = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "ERROR",
            text: error?.response?.data?.message ?? "Belum ada jabatan",
          });
        });
      await this.getOptionJabatan();
      this.$store.state.loading = false;
    },
    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text });
    },
    async submit() {
      if (!this.submitable) {
        this.$swal({
          icon: "error",
          title: "Form Belum Lengkap",
        })
      }
      else {
        this.$store.state.loading = true;
        if (this.$route.params.id) {
          await JabatanApi.update(this.$route.params.id, this.data).then(() => {
            this.$swal({
              icon: "success",
              title: "Berhasil",
            })
              .then(() => {
                this.$router.push({ name: "Jabatan" });
              })
              .catch((error) => {
                this.$swal({
                  icon: "error",
                  title: error?.response?.data?.message ?? "",
                });
              });
          });
        } else {
          await JabatanApi.post(this.data)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Berhasil",
              }).then(() => {
                this.$router.push({ name: "Jabatan" });
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: error?.response?.data?.message ?? "",
              });
            });
        }
        this.$store.state.loading = false;
      }
    },
    async getData() {
      this.$store.state.loading = true;
      await JabatanApi.get(this.$route.params.id)
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message,
          }).then(() => {
            this.$router.push({ name: "Competencies" });
          });
        });
      this.$store.state.loading = false;
    },
  },
};
</script>
